<script lang="ts">
import { defineComponent, inject } from 'vue'
import PrivacyMain from './Main.vue'
import PrivacyBreadcrumb from './Breadcrumb.vue'
import PageHeadingDefault from '@/components/_core/PageHeadingDefault.vue'

export default defineComponent({
  name: 'PrivacyApp',

  components: {
    PrivacyMain,
    PrivacyBreadcrumb,
    PageHeadingDefault,
  },

  setup() {
    // constants
    const EXTERNAL_URL = inject<Record<string, string>>('EXTERNAL_URL')

    return {
      // constants
      EXTERNAL_URL,
    }
  }
})
</script>

<template>
  <TemplateDefault :has-timeline="false">
    <template #pageHeading>
      <PageHeadingDefault small>
        個人情報保護方針
      </PageHeadingDefault>

      <p class="p">
        <a
          class="a"
          :href="EXTERNAL_URL!.smartcamp_privacy_policy_url">
          個人情報保護方針について詳しく見る
        </a>
      </p>
    </template>

    <template #main>
      <PrivacyMain />
    </template>

    <template #breadcrumbFooter>
      <PrivacyBreadcrumb />
    </template>
  </TemplateDefault>
</template>
